<template>
  <div class="role h100">
    <el-card>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <!-- 角色 -->
          <el-tab-pane label="系统角色" name="first">
            <!-- <el-form :inline="true">
              <el-form-item label="">
                <el-input v-model="searchKey" placeholder="请输入系统角色/描述"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchRole()">搜 索</el-button>
                <el-button type="primary" @click="changeRole()">添加系统角色</el-button>
              </el-form-item>
            </el-form> -->
            <!-- 角色列表 -->
            <el-table class="table-role" :data="roleData" border header-cell-class-name="headerStyle" cell-class-name="cellStyle">
              <!-- <el-table-column prop="roleCode" label="角色编码"></el-table-column> -->
              <el-table-column prop="roleCode" label="角色编码"></el-table-column>
              <el-table-column prop="roleName" label="系统角色"></el-table-column>
              <el-table-column prop="updateTime" label="配置时间"></el-table-column>
              <el-table-column prop="updateUser" label="配置者"></el-table-column>
              <!-- <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <span class="operation" @click="changeRole(scope.row)">修改</span>
                  <span class="operation operation_R" @click="deleteRole(scope.row.id)">删除</span>
                </template>
              </el-table-column> -->
            </el-table>
          </el-tab-pane>
          <!-- 渠道 -->
          <el-tab-pane label="渠道" name="second">
            <channel ref="channelRef"></channel>
          </el-tab-pane>
          <!-- 角色渠道与用户 -->
          <el-tab-pane label="角色渠道与用户" name="third">
            <roleChannelUserMapping ref="roleChannelUserMappingRef"></roleChannelUserMapping>
          </el-tab-pane>
          <!-- 角色与用户 -->
          <!-- <el-tab-pane label="系统角色与用户" name="four">
            <el-form :inline="true">
              <el-form-item label="选择系统角色">
                <el-select v-model="selectedRoleId" placeholder="请选择系统角色">
                  <el-option v-for="(items, index) in roleDataFilter" :key="index" :label="items.roleCode" :value="items.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="selectedRoleId !='' && filterRole()">搜 索</el-button>
              </el-form-item>
            </el-form> -->
            <!-- 角色对应明细 -->
            <!-- <el-transfer filterable :filter-method="filterMethod" @change="changeData()" filter-placeholder="请输入用户名" :titles="['可选用户', '已选用户']" v-model="selectedUserList" :data="userList"></el-transfer>
            <el-button style="margin:10px 0 0 748px" type="primary" @click="saveRoleUserMapping()">保 存</el-button>
          </el-tab-pane> -->
          <!-- <el-tab-pane label="角色与菜单" name="five">角色与菜单</el-tab-pane> -->
        </el-tabs>
    </el-card>
    <!-- 角色弹出框 -->
    <el-dialog  :title="title" width="30%" :visible.sync="dialogChangeRoleinfo" @close='handleCancel'>
      <el-form ref="roleInfoRef" :model="roleInfo" :rules="roleInfoRules" label-width="80px">
        <!-- <el-form-item prop="roleCode" label="角色编码">
          <el-input v-model="roleInfo.roleCode"></el-input>
        </el-form-item> -->
        <el-form-item prop="roleCode" label="系统角色" >
          <el-input v-model="roleInfo.roleCode"></el-input>
        </el-form-item>
        <el-form-item prop="roleName" label="角色描述">
          <!-- <el-input v-model="roleInfo.roleName"></el-input> -->
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4}" v-model="roleInfo.roleName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel()">取 消</el-button>
        <el-button type="primary" @click="handleSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import channel from './channel'
import roleChannelUserMapping from './roleChannelUserMapping'
export default {
  name: 'role',
  components: {
    channel,
    roleChannelUserMapping
  },
  data () {
    return {
      activeName: 'first',
      searchKey: '',
      roleData: [
        {
          roleCode: 1,
          roleName: 'zhang'
          // roleDescribe: 'admin'
        }
      ],
      dialogChangeRoleinfo: false,
      title: '',
      id: '',
      type: '',
      roleInfo: {
        roleCode: '',
        roleName: '',
        roleDescribe: ''
      },
      roleInfoRules: {
        roleCode: [
          { required: true, message: '请输入角色', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
        ],
        roleName: [
          { required: true, message: '请输入描述', trigger: 'blur' },
          { min: 2, max: 40, message: '长度在 2 到 40 个字符', trigger: 'blur' }
        ]
      },
      roleDataFilter: [],
      selectedRoleId: '',
      userList: [],
      selectedUserList: []
    }
  },
  created () {},
  mounted () {
    this.getRoleList()
  },
  methods: {
    // tabs切换形式
    handleClick (tab, event) {
      // console.log(tab)
      if (tab.label === '系统角色') {
        // 角色列表
        // this.getRoleList()
      } else if (tab.label === '渠道') {
        // 渠道列表
        // this.$refs.channelRef.getList()
      } else if (tab.label === '角色渠道与用户') {
        // 渠道角色与用户
        this.$refs.roleChannelUserMappingRef.getList()
      }
    },
    // 搜索角色
    searchRole () {
      // console.log(this.searchKey)
      this.$http.get(this.API.roleInfoList, { params: { searchKey: this.searchKey } }).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200 && data.data != null) {
          this.roleData = data.data
        } else if (data.data === null) {
          this.roleData = []
          this.$message.warning('暂无数据！')
        } else {
          this.roleData = []
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 获取角色列表
    getRoleList () {
      this.roleData = []
      this.$http.get(this.API.roleInfoList).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          this.roleData = data.data
          this.roleDataFilter = data.data
        } else {
          this.roleData = []
          this.$message.error('接口调用失败！')
        }
        // console.log(this.roleData)
      })
    },
    // 修改添加角色判断
    changeRole (type) {
      // console.log(type)
      // this.roleInfo = {}
      this.type = ''
      this.dialogChangeRoleinfo = true
      this.title = type ? '编辑系统角色' : '添加系统角色'
      this.type = type ? 'update' : 'create'
      if (type) {
        this.id = type.id
        this.roleInfo.roleCode = type.roleCode
        this.roleInfo.roleName = type.roleName
        // this.roleInfo.roleDescribe = type.roleDescribe
      }
    },
    // 删除角色
    deleteRole (id) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get(this.API.roleInfoDelete, { params: { id: id } }).then((res) => {
          let data = res.data
          if (data.code === 200) {
            this.getRoleList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('接口调用失败！')
          }
        })
      }).catch(() => {
        this.$message.warning('已取消删除！')
      })
    },
    // 取消
    handleCancel () {
      this.dialogChangeRoleinfo = false
      this.$refs.roleInfoRef.resetFields()
    },
    // 确认-新增和修改角色
    handleSubmit () {
      if (this.type === 'update') {
        this.$refs.roleInfoRef.validate((valid) => {
          if (valid) {
            this.dialogChangeRoleinfo = false
            this.roleInfo.id = this.id
            // this.roleInfo.updateUser = JSON.parse(sessionStorage.getItem('userInfo')).userName
            // 更新角色
            this.$http.post(this.API.roleInfoUpdate, this.roleInfo).then(res => {
              let data = res.data
              if (data.code === 200) {
                this.getRoleList()
                this.$message.success('修改成功！')
                this.$refs.roleInfoRef.resetFields()
              } else {
                this.$message.error('接口调用失败！')
                this.$refs.roleInfoRef.resetFields()
              }
            })
          }
        })
      } else {
        this.$refs.roleInfoRef.validate((valid) => {
          if (valid) {
            this.dialogChangeRoleinfo = false
            // 添加角色
            // this.roleInfo.createUser = JSON.parse(sessionStorage.getItem('userInfo')).userName
            this.$http.post(this.API.roleInfoSave, this.roleInfo).then((res) => {
              let data = res.data
              if (data.code === 200) {
                this.getRoleList()
                this.$message.success('添加成功！')
                this.$refs.roleInfoRef.resetFields()
              } else {
                this.$message.error('接口调用失败！')
                this.$refs.roleInfoRef.resetFields()
              }
            })
          }
        })
      }
    },
    // 筛选角色对应用户
    filterRole () {
      this.$http.get(this.API.queryAssociatedUserByRoleId, { params: { roleId: this.selectedRoleId } }).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          let userList = []
          let selectedUserList = []
          // 选中用户
          let associatedUser = data.data.associatedUser
          // 全部用户
          let userInfos = data.data.userInfos
          if (userInfos.length > 0) {
            userInfos.forEach((ele, index) => {
              userList.push({
                key: ele.id,
                label: ele.userName
              })
            })
          }
          if (associatedUser != null) {
            associatedUser.forEach((ele, index) => {
              selectedUserList.push(ele.id)
            })
          }
          this.userList = userList
          this.selectedUserList = selectedUserList
          // console.log(this.selectedUserList)
        }
      })
    },
    // 搜索用户
    filterMethod (query, item) {
      return item.label.indexOf(query) > -1
    },
    // 筛选发生变化
    changeData () {
      // console.log(this.selectedUserList)
    },
    // 保存角色与用户关系
    saveRoleUserMapping () {
      let roleUserMapping = {}
      let associatedUser = []
      let selectedUserList = this.selectedUserList
      if (selectedUserList.length > 0) {
        selectedUserList.forEach((ele, index) => {
          associatedUser.push({
            id: ele
          })
        })
      }
      roleUserMapping.id = this.selectedRoleId
      roleUserMapping.associatedUser = associatedUser
      this.$http.post(this.API.roleUserMappingSave, roleUserMapping).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          this.$message.success('修改关系成功！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
